import React from 'react'
import { ArrowPathIcon } from '@heroicons/react/24/outline'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  loading?: boolean
  disabled?: boolean
  type?: 'submit' | 'reset' | 'button' | undefined
  className?: string
}

export function ButtonPrimary(props: ButtonProps) {
  const { children, loading, type, className, disabled, ...rest } = props
  const resolveStyleClass = () => {
    const buttonClasses = [
      'w-full flex justify-center py-2 px-4 items-center gap-1',
      'border border-transparent shadow-sm text-sm font-medium text-white rounded-full mx-auto whitespace-nowrap',
      className || '',
    ]
    buttonClasses.push(
      loading || disabled
        ? 'bg-slate-600 cursor-not-allowed pointer-events-none'
        : 'bg-slate-900',
    )
    const buttonClass = buttonClasses.join(' ')
    return buttonClass
  }

  return (
    <button
      className={resolveStyleClass()}
      disabled={disabled || loading}
      type={type}
      {...rest}
    >
      {loading && (
        <span className="w-4 inline-block rounded animate-spin">
          <ArrowPathIcon />
        </span>
      )}
      {children}
    </button>
  )
}

ButtonPrimary.defaultProps = {
  loading: false,
  disabled: false,
  type: 'button',
  className: '',
}
